// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Accordion_arrow__Oz_xr","up":"Accordion_up__5H_D2","down":"Accordion_down___aklw","header":"Accordion_header__oyXDt"};